export default [
    {
        path: '/preferences',
        name: 'preferences',
        component: () => import('@/views/preferences/show'),
        meta: {pageTitle: 'preferences', breadcrumb: [{text: 'preferences'}]}
    },
   
]
